// Debug callback, used by export
export enum DebugCallbackType {
  DETECT_MATERIAL_OVERLAP,
  FACE_DEBUG,
  FACE_MITER,
  GENERATE_MATERIAL_WITHIN_FACES,
  MERGE_FACES_OF_SAME_CATEGORY,
  MERGE_FACES_OF_SAME_MATERIAL,
  SIMPLIFY_FACES,
}

export type DebugCallback = (any) => void;
export type DebugCallbacks = {
  [key in keyof DebugCallbackType]?: DebugCallback;
};

let debugId = 0;
export function getDebugId(): number {
  return debugId;
}
export function setDebugId(value: number) {
  debugId = value;
}
export function incDebugId() {
  debugId++;
}
